import { DurationSeconds } from 'lib/datetime/durationInSeconds'

const trackerName = 'sp'

/**
 * The live Snowplow collector. Events sent here land in production analytics.
 *
 * Declared here rather than at either use site because two things must agree on it: the environment
 * default in `constants/features/base.ts` and the guard in `analytics/resolveTrackingHost.ts`. If
 * they ever disagreed — say the collector moved domain and only one was updated — the guard would
 * stop recognising production traffic and silently stop protecting it.
 */
export const PRODUCTION_TRACKING_HOST = 'https://t.luxuryescapes.com'

/** The staging Snowplow collector every non-production environment must use. */
export const NON_PRODUCTION_TRACKING_HOST = 'https://test-t.luxuryescapes.com'

const Snowplow = {
  trackerName,
  domainUserIdCookie: `lux_${trackerName}_domain_user_id`,
  sessionIdCookie: `lux_${trackerName}_session_id`,
  sessionIdxCookie: `lux_${trackerName}_session_idx`,
  postPath: '/com.luxgroup/tp2',
}
export default Snowplow

// Snowplow renews browser-storage expiry on activity; this does not rotate identities.
export function getSnowplowCookieLifetime(consentRequired: boolean): number {
  return consentRequired ? DurationSeconds.ONE_YEAR : DurationSeconds.TWO_YEARS
}
